export default (flag) => ({
  name: "FlagTemplateCheckingSuggestions",

  data: function () {
    return {
      flag,
    };
  },

  render: function (h) {
    return h("ul", [h("li", ["Please follow the template guidelines. "])]);
  },
});
